import {
  PriceListConvertToBaseRequestType,
  PriceListConvertToBaseResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePriceListConvertToBase = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: PriceListConvertToBaseRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `price-lists/${data.id}/convert-to-base`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as PriceListConvertToBaseResponseType,
      ),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTiers],
      });
    },
  });
};
